import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardHeader,
  CardContent,
  IconButton,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useApiGet } from '../../utils/httpClient';
import { getBnBDetail } from '../../endpoints/resources';
import { Edit } from '@mui/icons-material';
import dayjs from 'dayjs';
import PositionDisplay from '../../Components/PositionDisplay';

export default function BnBDetail() {
  const [isSaving, setIsSaving] = useState(false);
  const [errorSaving, setErrorSaving] = useState(null);
  const { id } = useParams();
  const { data: bnbData, isLoading } = useApiGet(
    ['bnd-detail', id],
    getBnBDetail,
    {
      enabled: true,
      retry: 1,
    },
    {
      id,
    }
  );

  const canEdit = () => {
    // Add your logic to determine if the user can edit
    return false; // Placeholder, replace with actual logic
  };

  if (isLoading) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">Loading...</Typography>
      </Grid>
    );
  }
  if (!bnbData) {
    return (
      <Grid item xs={12} textAlign={'center'} paddingTop={2}>
        <Typography variant="body1">No data available</Typography>
      </Grid>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader
            title={bnbData.name}
            subheader={bnbData.is_active ? 'Active' : 'Inactive'}
            sx={{ p: 1 }}
          />
          <CardContent sx={{ p: 1 }}>
            <Grid container>
              <Grid item xs={12} md={6} padding>
                <Typography variant="body1">
                  <b>{'Name:'}</b> {bnbData.name}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} padding>
                <Typography variant="body1">
                  <b>{'Chapter:'}</b> {bnbData.chapter_name}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} padding>
                <Typography variant="body1">
                  <b>{'Status:'}</b> {bnbData.is_active ? 'Active' : 'Inactive'}
                </Typography>
              </Grid>
              <Grid item xs={12} padding>
                <Typography variant="body1">
                  <b>{'Note #1:'}</b> {bnbData.notes_1}
                </Typography>
              </Grid>
              <Grid item xs={12} padding>
                <Typography variant="body1">
                  <b>{'Note #2:'}</b> {bnbData.notes_2}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} padding>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title={'Contacts'} sx={{ p: 1 }} />
          <CardContent sx={{ p: 1 }}>
            {bnbData.contacts.map((contact) => (
              <PositionDisplay
                id={contact.id}
                position={'Contact'}
                positionId={null}
                committeeId={null}
                name={contact.name}
                startDate={contact.start_date}
                endDate={contact.end_date}
                canEdit={canEdit()}
                isSaving={isSaving}
                errorSavingText={errorSaving}
                onSave={null}
                userId={contact.user_id}
                pageFrom={'bnb'}
              />
            ))}
            {bnbData.contacts.length === 0 && (
              <Grid item xs={12} textAlign={'center'} paddingTop={2}>
                <Typography variant="body1">No contacts assigned</Typography>
              </Grid>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
